export const departmentManageMenu = [
  { title: "新建下级部门", command: "createSubDepartment" },
  { title: "编辑部门", command: "editDepartment" },
  { title: "删除部门", command: "deleteDepartment" }
]
